import React, { PureComponent } from 'react'
import { Card, CardBody, Col, Button } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import uuid from 'uuid'

class CardBasic extends PureComponent {
  render () {
    return (
      <Col
        className={this.props.className === 'paymentForm' ? this.props.className : ''}
        md={6} xl={3} sm={12}>
        <Card
          className={this.props.outline ?
            this.props.outline : 'pricing-card pricing-card--primary'}>
          <CardBody className='pricing-card__body'>
            <img className='pricing-card__img' src={this.props.src} alt='' />
            <h3 className='pricing-card__plan'>{this.props.name}</h3>
            <hr />
            <p className='pricing-card__price'>{`$${this.props.price}`}<span>/mo</span></p>
            {this.props.features.map((feature) => {
              return <p key={uuid()} className='pricing-card__feature'>{feature}</p>
            })}
            {!this.props.showButton
              ? null
              : <Button id='basic_button' onClick={
                () => this.props.history.push({
                  pathname: '/app/payments/updatepayment',
                  state: {
                    price: this.props.price,
                    name: this.props.name,
                    features: this.props.features,
                    src: this.props.src,
                    stripePlanId: this.props.stripePlanId
                  }
                })} className='pricing-card__button' color='primary'>Sign Up</Button>
            }
          </CardBody>
        </Card>
      </Col>
    )
  }
}

export default withRouter(CardBasic)



// WEBPACK FOOTER //
// ./src/components/pricing_cards/components/CardBasic.js